import { TextArea } from "@blueprintjs/core";
import { DailyInstantECharts } from "../charts/daily-instant";
import { useEffect, useState } from "react";
import { WeeklyPage } from "../components/WeeklyPage";
import { WeeklyHeader } from "../components/WeeklyHeader";
import {
  query,
  collection,
  where,
  limit,
  getDocs,
  orderBy,
} from "firebase/firestore";
import { fireStore } from "../../../../firebase";
import moment from "moment";
import { beforePreviousFridayNight } from "../util";
import { useChartDateContext } from "../chart-date-context";

export const Page16 = ({
  onPageDataUpdated,
  weekData,
  pageIndex,
  subIndex,
  registerPageIndex,
}: any) => {
  const [data30, setData30] = useState<any>(null);
  const [data70, setData70] = useState<any>(null);
  const [data500, setData500] = useState<any>(null);
  useEffect(() => {
    registerPageIndex(pageIndex, subIndex, "Haftalık Sentiment En Yüksek");
  }, []);
  const { chartDate } = useChartDateContext();

  useEffect(() => {
    const previousFriday = beforePreviousFridayNight(chartDate);

    const q = query(
      collection(fireStore, "NS_LINES_1W_P4"),
      orderBy("date", "desc"),
      where("date", "<=", previousFriday.toDate()),
      limit(1)
    );

    getDocs(q).then((querySnapshot: any) => {
      const doc = querySnapshot.docs[0];
      if (!doc) return;

      const list30 = [...(doc.data().lines030 ?? [])].sort(
        (a: any, b: any) => b.sentiment - a.sentiment
      );
      const list70 = [...(doc.data().lines070 ?? [])].sort(
        (a: any, b: any) => b.sentiment - a.sentiment
      );
      const list500 = [...(doc.data().lines200 ?? [])].sort(
        (a: any, b: any) => b.sentiment - a.sentiment
      );
      setData30(list30);
      setData70(list70);
      setData500(list500);
    });
  }, [chartDate]);

  return (
    <WeeklyPage cropped pageId={`page-${pageIndex}-${subIndex}`}>
      <WeeklyHeader title="HAFTALIK SENTIMENT PUANI EN YÜKSEK HİSSELER" />
      <div
        style={{
          display: "flex",
          gap: 20,
          justifyContent: "center",
          marginTop: 20,
          padding: "0 20px",
        }}
      >
        <div style={{ flex: 1 }}>
          <div
            style={{
              textAlign: "center",
              backgroundColor: "#F7AF3D",
              color: "black",
              padding: "5px 10px",
              fontWeight: "600",
              marginBottom: "12px",
              borderRadius: "2px",
              fontSize: "22px",
            }}
          >
            BİST 30
          </div>

          <table
            className="weekly-perf-table"
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontSize: "14px",
              borderTop: "1px solid #008099",
              borderBottom: "1px solid #008099",
            }}
          >
            <thead>
              <tr
                style={{
                  backgroundColor: "#008099",
                  color: "white",
                  border: "1px solid white",
                }}
              >
                <th
                  style={{
                    padding: "5px",
                    textAlign: "center",
                    border: "1px solid white",
                    borderLeft: "none",
                  }}
                >
                  #
                </th>
                <th
                  style={{
                    padding: "5px",
                    textAlign: "center",
                    border: "1px solid white",
                  }}
                >
                  Sembol
                </th>
                <th
                  style={{
                    padding: "5px",
                    textAlign: "center",
                    border: "1px solid white",
                  }}
                >
                  Fiyat
                </th>
                <th
                  style={{
                    padding: "5px",
                    textAlign: "center",
                    border: "1px solid white",
                    borderRight: "none",
                  }}
                >
                  Sentiment
                </th>
              </tr>
            </thead>
            <tbody>
              {data30?.slice(0, 10).map((doc: any, index: number) => {
                return (
                  <tr
                    key={index}
                    style={{
                      backgroundColor:
                        index % 2 !== 0 ? "rgba(0, 128, 153, 0.2)" : "white",
                      borderBottom: "1px solid #008099",
                      color: "black",
                      fontWeight: "600",
                    }}
                  >
                    <td
                      style={{
                        padding: "5px",
                        textAlign: "center",
                        border: "1px solid #008099",
                        borderLeft: "none",
                      }}
                    >
                      {index + 1}
                    </td>
                    <td
                      style={{
                        padding: "5px",
                        textAlign: "center",
                        border: "1px solid #008099",
                      }}
                    >
                      {doc.symbol}
                    </td>
                    <td
                      style={{
                        padding: "5px",
                        textAlign: "center",
                        border: "1px solid #008099",
                      }}
                    >
                      {doc.price}
                    </td>
                    <td
                      style={{
                        padding: "5px",
                        textAlign: "center",
                        border: "1px solid #008099",
                        borderRight: "none",
                      }}
                    >
                      {doc.sentiment}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div style={{ flex: 1 }}>
          <div
            style={{
              textAlign: "center",
              backgroundColor: "#F7AF3D",
              color: "black",
              padding: "5px 10px",
              fontWeight: "600",
              marginBottom: "12px",
              borderRadius: "2px",
              fontSize: "22px",
            }}
          >
            BİST 70
          </div>

          <table
            className="weekly-perf-table"
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontSize: "14px",
              borderTop: "1px solid #008099",
              borderBottom: "1px solid #008099",
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#008099", color: "white" }}>
                <th
                  style={{
                    padding: "5px",
                    textAlign: "center",
                    border: "1px solid white",
                    borderLeft: "none",
                  }}
                >
                  #
                </th>
                <th
                  style={{
                    padding: "5px",
                    textAlign: "center",
                    border: "1px solid white",
                  }}
                >
                  Sembol
                </th>
                <th
                  style={{
                    padding: "5px",
                    textAlign: "center",
                    border: "1px solid white",
                  }}
                >
                  Fiyat
                </th>
                <th
                  style={{
                    padding: "5px",
                    textAlign: "center",
                    border: "1px solid white",
                    borderRight: "none",
                  }}
                >
                  Sentiment
                </th>
              </tr>
            </thead>
            <tbody>
              {data70?.slice(0, 10).map((doc: any, index: number) => {
                return (
                  <tr
                    key={index}
                    style={{
                      backgroundColor:
                        index % 2 !== 0 ? "rgba(0, 128, 153, 0.2)" : "white",
                      borderBottom: "1px solid #008099",
                      color: "black",
                      fontWeight: "600",
                    }}
                  >
                    <td
                      style={{
                        padding: "5px",
                        textAlign: "center",
                        border: "1px solid #008099",
                        borderLeft: "none",
                      }}
                    >
                      {index + 1}
                    </td>
                    <td
                      style={{
                        padding: "5px",
                        textAlign: "center",
                        border: "1px solid #008099",
                      }}
                    >
                      {doc.symbol}
                    </td>
                    <td
                      style={{
                        padding: "5px",
                        textAlign: "center",
                        border: "1px solid #008099",
                      }}
                    >
                      {doc.price}
                    </td>
                    <td
                      style={{
                        padding: "5px",
                        textAlign: "center",
                        border: "1px solid #008099",
                        borderRight: "none",
                      }}
                    >
                      {doc.sentiment}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div style={{ flex: 1 }}>
          <div
            style={{
              textAlign: "center",
              backgroundColor: "#F7AF3D",
              color: "black",
              padding: "5px 10px",
              fontWeight: "600",
              marginBottom: "12px",
              borderRadius: "2px",
              fontSize: "22px",
            }}
          >
            Yıldız
          </div>
          <table
            className="weekly-perf-table"
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontSize: "14px",
              borderTop: "1px solid #008099",
              borderBottom: "1px solid #008099",
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#008099", color: "white" }}>
                <th
                  style={{
                    padding: "5px",
                    textAlign: "center",
                    border: "1px solid white",
                    borderLeft: "none",
                  }}
                >
                  #
                </th>
                <th
                  style={{
                    padding: "5px",
                    textAlign: "center",
                    border: "1px solid white",
                  }}
                >
                  Sembol
                </th>
                <th
                  style={{
                    padding: "5px",
                    textAlign: "center",
                    border: "1px solid white",
                  }}
                >
                  Fiyat
                </th>
                <th
                  style={{
                    padding: "5px",
                    textAlign: "center",
                    border: "1px solid white",
                    borderRight: "none",
                  }}
                >
                  Sentiment
                </th>
              </tr>
            </thead>
            <tbody>
              {data500?.slice(0, 15).map((doc: any, index: number) => {
                return (
                  <tr
                    key={index}
                    style={{
                      backgroundColor:
                        index % 2 !== 0 ? "rgba(0, 128, 153, 0.2)" : "white",
                      borderBottom: "1px solid #008099",
                      color: "black",
                      fontWeight: "600",
                    }}
                  >
                    <td
                      style={{
                        padding: "5px",
                        textAlign: "center",
                        border: "1px solid #008099",
                        borderLeft: "none",
                      }}
                    >
                      {index + 1}
                    </td>
                    <td
                      style={{
                        padding: "5px",
                        textAlign: "center",
                        border: "1px solid #008099",
                      }}
                    >
                      {doc.symbol}
                    </td>
                    <td
                      style={{
                        padding: "5px",
                        textAlign: "center",
                        border: "1px solid #008099",
                      }}
                    >
                      {doc.price}
                    </td>
                    <td
                      style={{
                        padding: "5px",
                        textAlign: "center",
                        border: "1px solid #008099",
                        borderRight: "none",
                      }}
                    >
                      {doc.sentiment}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </WeeklyPage>
  );
};
